import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/Operators';
import { Observable, throwError } from 'rxjs';
import { AppConfig } from '../../app.config';
import { BasicEmployeeDetails } from '../models/basicemployeedetails.model';
import { Designation } from '../models/Designation';
import { HREmployeeDetails } from '../models/hremployeecommunicationdetails.model';
import { HrEmployeeFinanceDetails } from '../models/hrEmpFinanceDtls';
import { HrEmployeePassportVisaInfo } from '../models/hrEmpPassportVisaDtls';
import { HrEmpPreviousEmploymentDetails } from '../models/hrEmpPrevEmpDtls';
import { HrEmpProfessionalReferenceDetails } from '../models/hrEmpReferenceDtls';
import { hrEmpPersonalDetails } from '../models/hrEmpPersonalDetails';
import { Awards } from '../models/Awards';
import { HrEmpEducationInfo } from '../models/HrEmpEducationInfo';
import { EmpInsurance } from '../models/EmpInsurance';
import { MasterData } from '../models/MasterData';
import { MasterDataDetails } from '../models/MasterDataDetails';
import { WinHRPagesUserMapping } from '../models/WinHRPagesUserMapping ';
import { InsurancePremiumDetails } from '../models/InsurancePremiumDetails';
import { SumAssuredDetails } from '../models/InsuranceSumAssuredDtls';
import { ProfileVerificationStatus } from '../models/ProfileVerificationStatus';
import { Offboarding } from '../models/Offboarding';
import { OffboardingCheckListResultClass } from '../models/OffboardingCheckListResultClass';
import { OffboardingSettings } from '../models/OffboardingSettings';
import { EmpFBAnswers } from '../models/EmpFBAnswers';
import { Department } from '../models/Department';
import { Cadre } from '../models/Cadre';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class MonthClosureService {

  constructor(private http: HttpClient, private config: AppConfig,
    private _userService: UserService
  ) { }
  private handleError(error: HttpErrorResponse) {
    return throwError(error.error);
  }
  getJoinerDetails(month:any): Observable<any> {
    return this.http.get(this.config.apiUrl + "HREmployeeApi/GetJoinerDetails?FY=All&month="+month).pipe(
      catchError(this.handleError)
    );
  }
  getAttritionDetails(month:any): Observable<any> {
    return this.http.get(this.config.apiUrl + "HrEmployeeApi/GetAttritionDetails?FY=All&month="+month).pipe(
      catchError(this.handleError)
    );
  }
  ExportToExcel(month:any): void {
    // const inputs = {
    //   month: month, // Example parameter
    // };
    const form = document.createElement('form');
    form.setAttribute('action', this.config.apiUrl + "HREmployeeApi/ExportAllowance?month=" + encodeURIComponent(month) );
   // form.setAttribute('action', this.config.apiUrl + "HREmployeeApi/ExportAllowance?month"+month);
    form.setAttribute('method', 'post');
 
        // const input = document.createElement('input');
        // input.type = 'hidden';
        // input.name = "month";
        // input.value = month;
        // form.appendChild(input);
   
    // If you need to add any inputs to the form, do it here
 
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }
  getVendors(): Observable<any> {
    return this.http.get(this.config.apiUrl + "HrEmployeeApi/GetVendorDetails").pipe(
      catchError(this.handleError)
    );
  }
  getOtherEarningDetails(month:any): Observable<any> {
    return this.http.get(this.config.apiUrl + "HREmployeeApi/GetOtherEarningDetails?FY=All&month="+month).pipe(
      catchError(this.handleError)
    );
  }

  getDeductionDetails(month:any): Observable<any> {
    return this.http.get(this.config.apiUrl + "HREmployeeApi/GetDeductionDetails?FY=All&month="+month).pipe(
      catchError(this.handleError)
    );
  }

  getDesignationChanges(month:any): Observable<any> {
    return this.http.get(this.config.apiUrl + "HREmployeeApi/GetDesignationChanges?month="+month).pipe(
      catchError(this.handleError)
    );
  }

  getLoPDetails(month:any): Observable<any> {
    return this.http.get(this.config.apiUrl + "HREmployeeApi/GetLoPDetails?FY=All&month="+month).pipe(
      catchError(this.handleError)
    );
  }
  saveResignationCommentsDetails(details: any) {
    return this.http.post(this.config.apiUrl + "HREmployeeApi/SaveResignationCommentsDetails", details).pipe(catchError(this.handleError));
  }
  saveLoPDetails(details: any) {
    return this.http.post(this.config.apiUrl + "HREmployeeApi/SaveLoPDetails", details).pipe(catchError(this.handleError));
  }
  saveDectionDetails(details: any) {
    return this.http.post(this.config.apiUrl + "HREmployeeApi/SaveDectionDetails", details).pipe(catchError(this.handleError));
  }
  saveOtherEarningsDetails(details: any) {
    return this.http.post(this.config.apiUrl + "HREmployeeApi/SaveOtherEarningsDetails", details).pipe(catchError(this.handleError));
  }
  saveJoinerDetails(details: any) {
    return this.http.post(this.config.apiUrl + "HREmployeeApi/SaveJoinerDetails", details).pipe(catchError(this.handleError));
  }
  saveAttritionDetails(details: any) {
    return this.http.post(this.config.apiUrl + "HREmployeeApi/SaveAttritionDetails", details).pipe(catchError(this.handleError));
  }
 
  getAllowanceNotication(month:any): Observable<any> {
    return this.http.get(this.config.apiUrl + "HREmployeeApi/GetAllowanceNotication?month="+month).pipe(
      catchError(this.handleError)
    );
  }
  getEmployeeAllowances(month:any): Observable<any> {
    return this.http.get(this.config.apiUrl + "HREmployeeApi/GetEmployeeAllowances?Empcode="+this._userService.getEmpCode()+"&month="+month).pipe(
      catchError(this.handleError)
    );
  }
  getCompletLogEmployeeAllowances(month:any): Observable<any> {
    return this.http.get(this.config.apiUrl + "HREmployeeApi/GetCompletLogEmployeeAllowances?month="+month).pipe(
      catchError(this.handleError)
    );
  }
  getApproverEmployeeList(month:any): Observable<any> {
    return this.http.get(this.config.apiUrl + "HREmployeeApi/GetApproverEmployeeList?Empcode="+this._userService.getEmpCode()+"&month="+month).pipe(
      catchError(this.handleError)
    );
  }
  getInWardEmployeeList(month:any): Observable<any> {
    return this.http.get(this.config.apiUrl + "HREmployeeApi/GetInWardEmployeeList?Empcode="+this._userService.getEmpCode()+"&month="+month).pipe(
      catchError(this.handleError)
    );
  }
  saveAllowanceNotication(details: any) {
    return this.http.post(this.config.apiUrl + "HREmployeeApi/SaveAllowanceNotication", details).pipe(catchError(this.handleError));
  }
  saveApprovedEmployeeAllowance(details: any) {
    return this.http.post(this.config.apiUrl + "HREmployeeApi/SaveApprovedEmployeeAllowance", details).pipe(catchError(this.handleError));
  }
  saveEmployeeAllowance(details: any) {
    return this.http.post(this.config.apiUrl + "HREmployeeApi/SaveEmployeeAllowance", details).pipe(catchError(this.handleError));
  }
  saveRejectedEmployeeAllowance(details: any) {
    return this.http.post(this.config.apiUrl + "HREmployeeApi/SaveRejectedEmployeeAllowance", details).pipe(catchError(this.handleError));
  }
  saveHRRejectedEmployeeAllowance(details: any) {
    return this.http.post(this.config.apiUrl + "HREmployeeApi/SaveHRRejectedEmployeeAllowance", details).pipe(catchError(this.handleError));
  }
  sendEmailAllowanceHRInitiate(details: any) {
    return this.http.post(this.config.apiUrl + "HREmployeeApi/SendEmailAllowanceHRInitiate", details).pipe(catchError(this.handleError));
  }
  getClients(): Observable<any> {
    return this.http.get(this.config.apiUrl + "WinTimeApi/GetClients").pipe(
      catchError(this.handleError)
    );
  }
  getProjects(clientId): Observable<any> {
    return this.http.get(this.config.apiUrl + "WinTimeApi/GetProjectsMonthClosure?ClientId="+clientId).pipe(
      catchError(this.handleError)
    );
  }

}
